<div class="cart-page">
  <app-category-nav />

  <div class="cart-page__content">

  <!-- ── Success screen ───────────────────────────────────────────────────── -->
  @if (submitted()) {
    <div class="cart-page__success">
      <div class="success-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="40" height="40">
          <polyline points="20 6 9 17 4 12"/>
        </svg>
      </div>
      <h1>Замовлення прийнято!</h1>
      <p>Ми зв'яжемося з вами найближчим часом для підтвердження.</p>
      <a class="cart-page__continue-btn" routerLink="/">Продовжити покупки</a>
    </div>
  }

  @if (!submitted()) {

    <div class="cart-page__header">
      <h1 class="cart-page__title">
        Кошик
        @if (cart.totalQuantity() > 0) {
          <span class="cart-page__count">{{ cart.totalQuantity() }} шт.</span>
        }
      </h1>
      <a class="cart-page__back" routerLink="/">← Продовжити покупки</a>
    </div>

    <!-- ── Empty state ─────────────────────────────────────────────────────── -->
    @if (cart.items().length === 0) {
      <div class="cart-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="64" height="64" opacity="0.25">
          <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
          <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/>
        </svg>
        <p>Кошик порожній</p>
        <a class="cart-page__continue-btn" routerLink="/">Перейти до каталогу</a>
      </div>
    }

    <!-- ── Cart layout ─────────────────────────────────────────────────────── -->
    @if (cart.items().length > 0) {
      <div class="cart-layout">

        <!-- Items list -->
        <div class="cart-items">
          @for (item of cart.items(); track item.productId + item.weightLabel) {
            <div class="cart-item">
              <a class="cart-item__img-wrap" [routerLink]="['/product', item.sku]">
                @if (item.imageUrl) {
                  <img [src]="item.imageUrl" [alt]="item.name" class="cart-item__img" />
                } @else {
                  <div class="cart-item__img-placeholder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="28" height="28" opacity="0.25">
                      <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/>
                      <polyline points="21 15 16 10 5 21"/>
                    </svg>
                  </div>
                }
              </a>

              <div class="cart-item__info">
                <a class="cart-item__name" [routerLink]="['/product', item.sku]">{{ item.name }}</a>
                @if (item.weightLabel) {
                  <p class="cart-item__weight">{{ item.weightLabel }}</p>
                }
                @if (item.price != null) {
                  <p class="cart-item__unit-price">{{ item.price | number:'1.2-2' }} грн / шт.</p>
                }
              </div>

              <div class="cart-item__controls">
                <div class="cart-item__qty">
                  <button class="cart-item__qty-btn" type="button" (click)="changeQty(item.productId, item.weightLabel, -1)">−</button>
                  <span class="cart-item__qty-val">{{ item.quantity }}</span>
                  <button class="cart-item__qty-btn" type="button" (click)="changeQty(item.productId, item.weightLabel, 1)">+</button>
                </div>
                @if (item.price != null) {
                  <p class="cart-item__subtotal">{{ item.price * item.quantity | number:'1.2-2' }} грн</p>
                }
              </div>

              <button
                class="cart-item__remove"
                type="button"
                (click)="cart.remove(item.productId, item.weightLabel)"
                title="Видалити"
              >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
                  <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
              </button>
            </div>
          }
        </div>

        <!-- Order summary + form -->
        <aside class="cart-summary">
          <h2 class="cart-summary__title">Оформлення замовлення</h2>

          <div class="cart-summary__total-row">
            <span>Разом ({{ cart.totalQuantity() }} шт.)</span>
            <strong>{{ cart.totalPrice() | number:'1.2-2' }} грн</strong>
          </div>

          <form class="order-form" (ngSubmit)="submitOrder()">
            <label class="order-form__field">
              <span class="order-form__label">Ім'я <span class="order-form__req">*</span></span>
              <input
                class="order-form__input"
                type="text"
                placeholder="Ваше ім'я"
                [(ngModel)]="form.name"
                name="name"
                required
              />
            </label>

            <label class="order-form__field">
              <span class="order-form__label">Телефон <span class="order-form__req">*</span></span>
              <input
                class="order-form__input"
                type="tel"
                placeholder="+38 (0XX) XXX-XX-XX"
                [(ngModel)]="form.phone"
                name="phone"
                required
              />
            </label>

            <label class="order-form__field">
              <span class="order-form__label">Коментар</span>
              <textarea
                class="order-form__input order-form__input--textarea"
                placeholder="Побажання щодо доставки або товару"
                [(ngModel)]="form.comment"
                name="comment"
                rows="3"
              ></textarea>
            </label>

            <button
              class="order-form__submit"
              type="submit"
              [disabled]="submitting() || !form.name.trim() || !form.phone.trim()"
            >
              @if (submitting()) {
                Відправляємо…
              } @else {
                Підтвердити замовлення
              }
            </button>
          </form>
        </aside>

      </div>
    }

  }

  </div>
</div>
